// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import '@babel/polyfill'
import 'babel-polyfill' //兼容IE
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
//npm install vue-resource --save-dev
import VueResource from 'vue-resource'
//引入element组件开发npm i element-ui -S
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
//引入echarts图标 npm install echarts --save
import echarts from 'echarts'
import 'echarts/lib/chart/map';
//引入网页title插件使用npm install vue-wechat-title --save
import VueWechatTitle from 'vue-wechat-title';
//打印
import Print from 'vue-print-nb'
import VueClipboard from 'vue-clipboard2'
//图片浏览组件https://blog.csdn.net/yp090416/article/details/81486581   npm install v-viewer --save
import Viewer from 'v-viewer'
//百度地图npm install vue-baidu-map --save  https://dafrok.github.io/vue-baidu-map/#/zh/start/installation
import BaiduMap from 'vue-baidu-map'
import imageViewer from '@/components/imageViewer/imageViewer'; //图片查看
//vue的全局变量
import Global_ from '../static/js/config/Global.js';
import AES_ from '../static/js/function/aes.js'
// //全局拦截器和路由进度条
import './permission'; // permission control

Vue.use(VueResource)

Vue.use(ElementUI, {size: 'small'})

Vue.prototype.$echarts = echarts

Vue.use(VueWechatTitle)

Vue.use(Print)
//粒子特效npm install vue-particles --save-dev   https://www.jianshu.com/p/53199b842d25
// import VueParticles from 'vue-particles'
// Vue.use(VueParticles)

// 使用复制剪切功能
Vue.use(VueClipboard)

// import 'viewerjs/dist/viewer.min.css'
//Vue.use(Viewer) 默认配置写法
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: '3mjT2P0DgpgVUfWGUkATGcibED1p95rB'
})

Vue.component('imageViewer', imageViewer)


Vue.prototype.GLOBAL = Global_;

Vue.prototype.AES = AES_;


// Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  store: store,
  components: {App: App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js